<template>
  <div class="descriptionPage">
    <div v-show="show1">
      <description @enter="enter"
                   @goBack="goBack">
        <template v-slot:content>广发银行是一家总部位于广州的银行，成立于1984年。目前，在中国的27个省份、香港和澳门设有49家直属分行和968家营业机构，覆盖116个城市。广发银行提供综合金融服务，致力于为客户提供高质量、高效率的服务。它还荣获了多个奖项，被认可为数字化转型的倡议者，并在扶贫领域表现出色。广发银行将继续创新，为客户提供卓越的金融服务。
          开立个人养老金资金账户用户须知：依照规定，参加人需要开立个人养老金账户与个人养老金资金账户。个人养老金账户需通过国家社会保险公共服务平台、全国人社政务服务平台等全国统一线上服务入口或商业银行开立；个人养老金资金账户需通过商业银行开立。广发银行现在推出“养老早计划，预约享好礼”预约开立个人养老金资金账户活动。通过广发银行开设养老金资金账户可享个50元生活福利券。活动详细可通过广发APP查看。
          WOYOU工资平台并非直接办理银行业务，而是以网络空间经营场所的形式，为用户提供一站式的便利服务。作为银行信息发布平台和链接跳转的技术服务，我们的主要职责是推广银行业务，特别是个人养老金资金账户的开立服务。当然，具体的业务办理仍需要跳转到银行的业务端口，以获取更详细的信息。我们希望以上信息能对您有所帮助。如果您还有其他疑问或需要更多帮助，请随时与我们联系。我们将竭诚为您提供卓越的服务。</template>
        <template v-slot:btn>
          <el-button type="primary"
                     size="medium"
                     @click="enter">确认</el-button>
        </template>
      </description>
      <el-dialog title="确认个人信息"
                 :visible.sync="enterVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="440px"
                 center
                 @close="resetForm">
        <el-form ref="companyform"
                 :model="form"
                 :rules="rules"
                 label-width="135px"
                 size="small"
                 v-enterToNext="true">
          <el-form-item label="姓名"
                        prop="cname">
            <el-input v-model="form.cname"
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="手机号码"
                        prop="tel">
            <el-input v-model="form.tel"
                      maxlength="11"> </el-input>
          </el-form-item>
          <el-form-item label="身份证"
                        prop="identityCard">
            <el-input v-model="form.identityCard"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="(enterVisible = false), resetForm">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="confirm('companyform')">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="提示"
                 :visible.sync="tipVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="440px"
                 center
                 @close="resetForm">
        确认申请养老金账户吗？
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="tipVisible = false">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="send()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="生成申请二维码成功"
                 :visible.sync="urlVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="440px"
                 center
                 @close="nav">
        <div style="text-align: center">请使用微信扫描此二维码进行申请</div>
        <div style="display: flex; justify-content: center; margin-top: 10px">
          <div v-for="item in bankInfoList"
               :key="item.id">
            <div style="margin-top: 10px; display: flex">
              <img :src="item.imgPath"
                   alt=""
                   v-if="$shareType == 2" />
              <div :id="item.bankName"
                   :ref="item.bankName"
                   v-if="$shareType == 1"></div>
            </div>
          </div>
        </div>
        <!-- <div style="margin-top: 10px">https://n.95508.com/7FD6oO52f</div> -->
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="nav">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="nav">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- <transition name="el-zoom-in-bottom">
      <CardList v-if="show2" @noteCard="noteCard" />
    </transition> -->
  </div>
</template>

<script>
import CardList from "./CardList";
import description from "@/components/description";
import QRCode from "qrcodejs2";
import { GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import IDCard from "china-id-card";
import { baseUrl } from "../../request/url";
export default {
  components: {
    CardList,
    description,
  },
  props: {
    bankInfoList: Array,
  },
  mixins: [GetUnlimitedQRCodeMinix],
  data () {
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validateIdcard = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value) {
        callback();
      }
      if (IDCard(value).isVerified != true) {
        callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      form: {},
      rules: {
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        tel: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        identityCard: [{ validator: validateIdcard, trigger: "blur" }],
      },
      submitLoading: false,
      enterVisible: false,
      tipVisible: false,
      detail: "",
      show1: true,
      show2: false,
      urlVisible: false,
      mydata: "",
      CompanyAutoIntId: "",
      userAutoIntId: "",
      imgPath: "",
    };
  },
  created () {
    // this.CompanyDetail();
    let detail = JSON.parse(window.localStorage.getItem("userInfo"));
    this.userAutoIntId = detail.autoIntId;
    this.CompanyAutoIntId = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    ).autoIntId;
    this.$set(this.form, "cname", detail.cname);
    this.$set(this.form, "tel", detail.tel);
    this.$set(this.form, "identityCard", detail.identityCard);
  },
  methods: {
    closeDialog () {
      if (this.$shareType == 1) {
        this.bankInfoList.forEach((item) => {
          document.getElementById(item.bankName).innerHTML = "";
        });
      }
    },
    qrcode () {
      this.submitLoading = true;

      this.bankInfoList.forEach((item, i) => {
        if (this.$shareType == 1) {
          let qrcode = new QRCode(item.bankName, {
            width: 100, // 设置宽度，单位像素
            height: 100, // 设置高度，单位像素
            text:
              baseUrl.website +
              "/#/pages/webView/transferPage?id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
            // 设置二维码内容或跳转地址
          });
          console.log(
            baseUrl.website +
            "/#/pages/webView/transferPage?id=" +
            item.bankAutoIntId +
            "-" +
            item.autoIntId +
            "-" +
            item.userAutoIntId +
            "-" +
            item.CompanyAutoIntId
          );
          this.submitLoading = false;
        }
        if (this.$shareType == 2) {
          let sendData = {
            page: "pages/webView/transferPage",
            check_path: false,
            width: 150,
            scene:
              "id=" +
              item.bankAutoIntId +
              "-" +
              item.autoIntId +
              "-" +
              item.userAutoIntId +
              "-" +
              item.CompanyAutoIntId,
          };
          this.GetUnlimitedQRCode(sendData).then((res) => {
            item.imgPath = "data:image/png;base64," + res;
            if (this.bankInfoList.length - 1 == i) {
              this.submitLoading = false;
            }
            this.urlVisible = true;
          });
        }
      });
    },

    goBack () {
      this.$parent.show1 = true;
      this.$parent.show3 = false;
    },
    noteCard (flag) {
      if (flag == true) {
        this.$parent.show1 = true;
        this.$parent.show3 = false;
      } else {
        this.show1 = !this.show1;
        this.show2 = !this.show2;
      }
    },
    send () {
      // this.submitLoading = true;
      // console.log(this.bankInfoList[0].sendCC);
      // console.log(this.bankInfoList[0].sendTo);
      // let sendData = {
      //   companyId: this.detail.id,
      //   companyName: this.form.companyName,
      //   creditCode: this.form.creditCode,
      //   address: this.form.address,
      //   contactName: this.form.contactName,
      //   contactPhone: this.form.contactPhone,
      //   bankId: this.bankInfoList[0].bankId,
      //   bankName: this.bankInfoList[0].bankName,
      //   bankUniqueFlag: "CGB",
      //   sendTo: "1274094508@qq.com",
      //   emailSubject: "易奇推荐函",
      //   emailBodyIsHtml: true,
      // };
      // this.$api.email.SentEmailToBankByNetCoreLogic(sendData).then((res) => {
      //   this.submitLoading = false;

      //   if (res.error === false) {
      //     this.show1 = !this.show1;
      //     this.show2 = !this.show2;
      //     this.tipVisible = false;
      //     this.enterVisible = false;
      //   
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
      if (this.$shareType == 1) {
        this.urlVisible = true;
      }
      this.$nextTick(() => {
        this.qrcode();
      });
    },
    nav () {
      this.closeDialog();
      this.urlVisible = false;
      this.tipVisible = false;
      this.enterVisible = false;
      this.$parent.show1 = false;
      this.$parent.show2 = true;
      this.$parent.show3 = false;
    },
    CompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.detail = res.data;
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);

        }
      });
    },
    resetForm () { },
    enter () {
      this.enterVisible = true;
      this.$set(this.form, "companyName", this.detail.companyName);
      this.$set(this.form, "address", this.detail.address);
      this.$set(this.form, "contactName", this.detail.contactName);
      this.$set(this.form, "contactPhone", this.detail.contactPhone);
      this.$set(this.form, "creditCode", this.detail.creditCode);
    },
    drawermonstransVisibleClose () {
      this.$emit("close");
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.tipVisible = true;
        }
      });
    },
  },
  watch: {},
};
</script>
<style lang="less">
.descriptionPage .el-dialog__body {
  padding: 10px 20px;
}
</style>
<style lang="less" scoped>
.descriptionPage {
  .title {
    text-align: center;
    font-size: 20px;
  }
  .content {
    padding: 20px 300px;
    line-height: 25px;
  }
  .btnBox {
    position: fixed;
    bottom: 60px;
    left: calc(50% - 82px);
    text-align: center;
    .btn {
      margin-top: 10px;
    }
  }
}
</style>